import { render, staticRenderFns } from "./report-pulse6.vue?vue&type=template&id=36eff296&scoped=true"
import script from "./report-pulse6.vue?vue&type=script&lang=ts"
export * from "./report-pulse6.vue?vue&type=script&lang=ts"
import style0 from "./report-pulse6.vue?vue&type=style&index=0&id=36eff296&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eff296",
  null
  
)

export default component.exports